// ApiInterceptorInitializer.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../services/apiService';
import { AxiosError } from 'axios';

const ApiInterceptorInitializer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = apiClient.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => {
        if (error.response?.status === 401) {
          navigate('/login');
        }
        return Promise.reject(error);
      }
    );

    return () => {
      apiClient.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  return null;
};

export default ApiInterceptorInitializer;
